import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemVariantOptionRelationsMutation
 * @since 1.0.0
 */
export const ImportSaleItemVariantOptionRelationsMutation = gql `
  mutation ImportSaleItemVariantOptionRelationsMutation($input: ImportSaleItemVariantOptionRelationsInput!) {
    importSaleItemVariantOptionRelations(input: $input)
  }
`;
